import { formatVideoUrl } from "./VideoStringHandler";
import { showModal, setupModalListeners } from "./ModalUtils";

interface VideoCommand {
    event: string;
    func: string;
    args: string | string[];
}

export const getIframeSrc = (iframe: HTMLIFrameElement | null): string | null => {
    if (!iframe) return null;
    return iframe.getAttribute("data-src") || iframe.getAttribute("src");
};

export const postIframeCommand = (iframe: HTMLIFrameElement | null, command: VideoCommand): void => {
    if (!iframe?.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify(command), "*");
};

export const pauseIframeVideo = (iframe: HTMLIFrameElement | null): void => {
    postIframeCommand(iframe, { event: "command", func: "pauseVideo", args: "" });
};

export const findVideoRoot = (element: HTMLElement, classNames: string[]): HTMLElement | null => {
    const selector = classNames.map(name => `.${name}`).join(', ');
    return element.closest<HTMLElement>(selector);
};

export const clearActiveVideo = (className: string): void => {
    const activeEl = document.querySelector<HTMLElement>(`.${className}.active`);
    if (!activeEl) return;

    const iframe = activeEl.querySelector<HTMLIFrameElement>("iframe");
    pauseIframeVideo(iframe);
    activeEl.classList.remove("active");
};

export const initVideoModals = (videoRootClass: string, inline: boolean = false) => {
    const playButtons = document.querySelectorAll<HTMLElement>(".play-btn");

    const handlePlayClick = (e: MouseEvent) => {
        const btn = e.currentTarget as HTMLElement;
        const rootElement = findVideoRoot(btn, [videoRootClass]);
        const iframe = rootElement?.querySelector<HTMLIFrameElement>("iframe") ?? null;

        const rawSrc = getIframeSrc(iframe);
        if (!rootElement || !iframe || !rawSrc) return;

        clearActiveVideo(videoRootClass);

        const formattedUrl = formatVideoUrl(rawSrc, {
            autoplay: true,
            enableJsApi: true
        });
        iframe.setAttribute("src", formattedUrl);

        rootElement.classList.add("active");
        if (!inline) {
            showModal();
            setupModalListeners(() => clearActiveVideo(videoRootClass));
        }
    };

    // Attach listeners
    playButtons.forEach(btn => {
        btn.removeEventListener("click", handlePlayClick);
        btn.addEventListener("click", handlePlayClick);
    });
};